import { DividerLook } from "./Divider.types";
const lookToColor = (look) => {
    switch (look) {
        case DividerLook.PRIMARY:
            return "semantic.border.primary";
        case DividerLook.SECONDARY:
            return "semantic.border.secondary";
        default:
            return "transparent";
    }
};
export { lookToColor };
//# sourceMappingURL=Divider.helpers.js.map